import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { BASE_URL } from "../../Config/api.config";
import useLocalStorage from "../../Hooks/useLocalStorage";
import Statistics from "./Statistics"; // Componente de gráficos
ChartJS.register(ArcElement, Tooltip, Legend);

const StatisticsPanel = () => {
  const [adminData] = useLocalStorage("adminData", "");
  const [statsData, setStatsData] = useState({ showClients: "all" });
  const [chartData, setChartData] = useState({ fetchedData: [] }); // Inicializamos como array
  const [loading, setLoading] = useState(true);

  // Fetch para obtener todos los clientes
  const getAllClients = (param = "all") => {
    fetch(
      `${BASE_URL}adm.clients${
        param === "all"
          ? ""
          : param === "validated"
          ? "?validated=1"
          : "?active=1"
      }`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${adminData.uid}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) =>
        setStatsData((prev) => ({
          ...prev,
          totalClients: data.result.clients || [],
        }))
      )
      .catch(console.log);
  };

  // Fetch de gráficos
  const getBalanceData = () => {
    fetch(
      `${BASE_URL}adm.graph.clients?date_start=2023-01-01&date_end=2023-03-09&client_type=1`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${adminData.uid}` },
      }
    )
      .then((res) => res.json())
      .then((data) => setChartData({ fetchedData: data.result.clients || [] }))
      .catch(console.log);
  };

  // Fetch de jobs
  const getJobsData = () => {
    fetch(`${BASE_URL}adm.jobs`, {
      headers: { Authorization: `Bearer ${adminData.uid}` },
    })
      .then((res) => res.json())
      .then((data) =>
        setStatsData((prev) => ({
          ...prev,
          jobStatus: data.result.jobsStatus || [],
          jobsTimeState: data.result.jobsTimeState || [],
          jobsTypes: data.result.jobsTypes || [],
          top10jobs: data.result.top10_jobsCategories || [],
          totalJobs: data.result.totalJobs || 0,
        }))
      )
      .catch(console.log);
  };

  useEffect(() => {
    // Ejecutamos los tres fetches en paralelo
    Promise.all([getAllClients(), getJobsData(), getBalanceData()]).then(() =>
      setLoading(false)
    );
  }, []);

  if (loading)
    return (
      <div className="p-4">
        <p>Cargando estadísticas...</p>
      </div>
    );

  return (
    <div className="bg-[#E8E8E8] flex flex-col rounded-xl shadow max-h-[700px] jobpost overflow-auto p-4">
      <Statistics
        statsData={statsData}
        setStatsData={setStatsData}
        getAllClients={getAllClients}
        chartData={chartData}
        setChartData={setChartData}
      />
    </div>
  );
};

export default StatisticsPanel;
